export const titlerHardKodet: ITitel[] = [
  {
    Id: "9199595B-7531-437C-9951-00C158D2E309",
    TitelNr: 248,
    Titel: "HR Manager",
    Navn: "HR Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:05.987Z",
    RetteInit: "jca",
  },
  {
    Id: "B76795F7-67CA-47CF-BB4E-00CC2F281F80",
    TitelNr: 671,
    Titel: "INSTITUTLE",
    Navn: "Institutleder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2009-03-20T10:46:29.913Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:52:59.017Z",
    RetteInit: "jca",
  },
  {
    Id: "0BAAC239-4713-41DB-8DEA-00DBC6805A86",
    TitelNr: 548,
    Titel: "Sekretaria",
    Navn: "Sekretariatschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:12:01.960Z",
    RetteInit: "jca",
  },
  {
    Id: "CC30304E-804A-4F7C-B408-010E5E9369A1",
    TitelNr: 432,
    Titel: "National D",
    Navn: "National Director",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:04:43.940Z",
    RetteInit: "jca",
  },
  {
    Id: "1473D1A7-9028-4E21-B099-016210FD5020",
    TitelNr: 29,
    Titel: "Advokatful",
    Navn: "Advokatfuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:40:24.113Z",
    RetteInit: "jca",
  },
  {
    Id: "ADCF1AE7-1AF4-46FD-B260-03215996B749",
    TitelNr: 503,
    Titel: "Reg. Ejend",
    Navn: "Reg. Ejendomsformidler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:09:24.057Z",
    RetteInit: "jca",
  },
  {
    Id: "7CB14742-D0FC-46E2-A062-0324880B7242",
    TitelNr: 55,
    Titel: "Auktionsle",
    Navn: "Auktionsleder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:42:12.767Z",
    RetteInit: "jca",
  },
  {
    Id: "E8A81142-09F7-4CB0-A5BA-05344A761479",
    TitelNr: 302,
    Titel: "Juridisk m",
    Navn: "Juridisk medarbejder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:15.143Z",
    RetteInit: "jca",
  },
  {
    Id: "7442C719-DAEE-4204-BA4D-05B60D549CFA",
    TitelNr: 167,
    Titel: "Ekstern le",
    Navn: "Ekstern lektor, autoriseret bobestyrer.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:38.133Z",
    RetteInit: "jca",
  },
  {
    Id: "0392E6D7-C890-43D9-8368-0665AB65387B",
    TitelNr: 595,
    Titel: "Statsadv",
    Navn: "Statsadvokatfuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:16:06.960Z",
    RetteInit: "jca",
  },
  {
    Id: "88495E43-E340-4544-95BF-07BC2688BE86",
    TitelNr: 409,
    Titel: "Master of ",
    Navn: "Master of Laws",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:47.720Z",
    RetteInit: "jca",
  },
  {
    Id: "CC70E7E0-4C6A-45C4-9006-094EDD9FF6B6",
    TitelNr: 468,
    Titel: "Politifm",
    Navn: "Politifuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:07:21.580Z",
    RetteInit: "jca",
  },
  {
    Id: "4CAB8F66-B3EA-44EE-9D44-09D96DA933A5",
    TitelNr: 5,
    Titel: "Adjungeret",
    Navn: "Adjungeret professor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2022-06-14T08:40:44.563Z",
    RetteInit: "lra",
  },
  {
    Id: "0CEC817E-07FA-4873-9CC3-0A38E63C4DC6",
    TitelNr: 75,
    Titel: "Boligadvok",
    Navn: "Boligadvokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:43:36.807Z",
    RetteInit: "jca",
  },
  {
    Id: "F62EDB30-1442-4C0F-B38D-0AF811ABC381",
    TitelNr: 299,
    Titel: "Juridisk c",
    Navn: "Juridisk chef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:46.673Z",
    RetteInit: "jca",
  },
  {
    Id: "AE7AD3F2-4CDA-4EF4-983F-0B129285E07C",
    TitelNr: 369,
    Titel: "Lektor, dr",
    Navn: "Lektor, dr.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "A16A2CD9-4C95-45B6-986D-0B41D4838E15",
    TitelNr: 341,
    Titel: "Kst. lands",
    Navn: "Kst. landsdommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:58:15.980Z",
    RetteInit: "jca",
  },
  {
    Id: "E9185309-2BEE-4111-83E7-0BA5279D9E1E",
    TitelNr: 297,
    Titel: "juridisk a",
    Navn: "Juridisk assistent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:43.367Z",
    RetteInit: "jca",
  },
  {
    Id: "26692639-108D-4BED-9BE6-0D19E78540AA",
    TitelNr: 184,
    Titel: "fhv. Kommu",
    Navn: "fhv. Kommunaldirektør/Folketingsmedlem",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:44.027Z",
    RetteInit: "jca",
  },
  {
    Id: "E2E294FB-6BB3-4CAA-8222-0E945575F5B9",
    TitelNr: 111,
    Titel: "Chefjurist",
    Navn: "Chefjurist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:46:23.897Z",
    RetteInit: "jca",
  },
  {
    Id: "BBFF504D-229B-4030-AF59-10CD45491490",
    TitelNr: 440,
    Titel: "org.sekr.",
    Navn: "Organisationssekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:05:17.387Z",
    RetteInit: "jca",
  },
  {
    Id: "28EBC426-5CA7-4B85-9016-113F75580F70",
    TitelNr: 511,
    Titel: "Rektor",
    Navn: "Rektor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:09:48.160Z",
    RetteInit: "jca",
  },
  {
    Id: "7A486D7E-1283-4796-AAB0-11572F685155",
    TitelNr: 527,
    Titel: "rigsadvful",
    Navn: "Rigsadvokatfuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:56.393Z",
    RetteInit: "jca",
  },
  {
    Id: "E933997B-CE55-4672-93AD-116DFE9CBFB0",
    TitelNr: 215,
    Titel: "General Co",
    Navn: "General Counsel",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:49.393Z",
    RetteInit: "jca",
  },
  {
    Id: "B7A8DE68-E615-4524-A90A-11F6DB10E909",
    TitelNr: 604,
    Titel: "Stud.jur.",
    Navn: "Stud.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:16:29.143Z",
    RetteInit: "jca",
  },
  {
    Id: "AA513AF8-4581-4E9E-81E9-12FED919E999",
    TitelNr: 445,
    Titel: "Overretssa",
    Navn: "Overretssagfører",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:05:45.703Z",
    RetteInit: "jca",
  },
  {
    Id: "7CE71100-6DC2-4113-97DB-1455BB7FD1DF",
    TitelNr: 163,
    Titel: "Ejendomsko",
    Navn: "Ejendomskonsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:23.390Z",
    RetteInit: "jca",
  },
  {
    Id: "7A70E72B-32FE-4557-98DF-14669B5AB152",
    TitelNr: 367,
    Titel: "Lektor ph",
    Navn: "Lektor Ph.d.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:00:08.677Z",
    RetteInit: "jca",
  },
  {
    Id: "2FE67C90-BB8E-48D0-BDA8-153ADB5A2405",
    TitelNr: 265,
    Titel: "inkasso",
    Navn: "Inkassochef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:52:28.020Z",
    RetteInit: "jca",
  },
  {
    Id: "77A39810-E806-4B3A-B0F4-15CA830B4289",
    TitelNr: 116,
    Titel: "Chefsek",
    Navn: "Chefsekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:07.437Z",
    RetteInit: "jca",
  },
  {
    Id: "B084D8BC-685A-4236-B53F-15E72C8C7199",
    TitelNr: 92,
    Titel: "Cand.agro",
    Navn: "Cand.agro",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:45:08.643Z",
    RetteInit: "jca",
  },
  {
    Id: "54C95AE3-5614-409C-8EB9-17577B3BA5C9",
    TitelNr: 186,
    Titel: "Financial ",
    Navn: "Financial Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:51.063Z",
    RetteInit: "jca",
  },
  {
    Id: "471A6055-AA7B-4259-9A18-17EC5A636C1B",
    TitelNr: 2,
    Titel: "Abogado",
    Navn: "Abogado",
    FalId: "8C88CC2A-0507-4029-BD98-AB48A6E49319",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2007-09-19T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T12:59:40.300Z",
    RetteInit: "jca",
  },
  {
    Id: "24AAB465-AB11-4376-898B-1A1D7F4CAF6D",
    TitelNr: 359,
    Titel: "Legal advi",
    Navn: "Legal Advisor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:59:33.060Z",
    RetteInit: "jca",
  },
  {
    Id: "AEC1A955-7D26-4E97-B1EF-1B546CE7A172",
    TitelNr: 467,
    Titel: "politidir",
    Navn: "Politidirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:07:17.773Z",
    RetteInit: "jca",
  },
  {
    Id: "FCA3A0CB-7D21-4C10-9427-1D9E52B62B40",
    TitelNr: 61,
    Titel: "Avocat au ",
    Navn: "Avocat au Barreau de Paris",
    FalId: "763488A7-D1F2-47FE-BE08-43A7070AA8AA",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:04:57.240Z",
    RetteInit: "jca",
  },
  {
    Id: "BED60034-5A80-43EE-AF29-1DDC4A3212E0",
    TitelNr: 433,
    Titel: "Norsk advo",
    Navn: "Norsk advokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:04:54.847Z",
    RetteInit: "jca",
  },
  {
    Id: "09868AAB-85FB-4496-AEE5-2075A8E17127",
    TitelNr: 480,
    Titel: "Professor",
    Navn: "Professor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:07:55.730Z",
    RetteInit: "jca",
  },
  {
    Id: "BF4977D3-54DB-4DF2-8C23-211DD94FFFE7",
    TitelNr: 177,
    Titel: "FAF-mediat",
    Navn: "FAF-mediator",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:07.413Z",
    RetteInit: "jca",
  },
  {
    Id: "70C2F2B3-8748-4F65-8A70-2191FDECF58C",
    TitelNr: 154,
    Titel: "Dommer",
    Navn: "Dommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:49:32.487Z",
    RetteInit: "jca",
  },
  {
    Id: "BD906964-903E-4BFC-9C5E-21BC8089EC39",
    TitelNr: 474,
    Titel: "Proceduref",
    Navn: "Procedurefuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:07:40.690Z",
    RetteInit: "jca",
  },
  {
    Id: "53C95A53-3346-48CC-99F4-2229AF868E16",
    TitelNr: 418,
    Titel: "mediator o",
    Navn: "mediator og retsmægler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:21.400Z",
    RetteInit: "jca",
  },
  {
    Id: "C83DCFB6-4A65-4ABA-9C79-2291398554EF",
    TitelNr: 583,
    Titel: "Solicitor,",
    Navn: "Solicitor, LL.M.",
    FalId: "E0E8FD63-A007-4F8D-8A7E-E4FC71373A1D",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:12:27.020Z",
    RetteInit: "jca",
  },
  {
    Id: "6D990AC1-1103-40C6-ADD6-2532327BA303",
    TitelNr: 534,
    Titel: "Sagsbehand",
    Navn: "Sagsbehandler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:11:22.383Z",
    RetteInit: "jca",
  },
  {
    Id: "79477716-758B-424D-B039-2711F066A482",
    TitelNr: 288,
    Titel: "jur chef",
    Navn: "Juridisk chefkonsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:53.727Z",
    RetteInit: "jca",
  },
  {
    Id: "F3215D72-3D68-4332-B70C-288FCD3863A4",
    TitelNr: 637,
    Titel: "Vice",
    Navn: "Vicedirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:18:53.837Z",
    RetteInit: "jca",
  },
  {
    Id: "7BDF4D45-C432-424D-ADD4-29222274589D",
    TitelNr: 59,
    Titel: "Autorisere",
    Navn: "Autoriseret bobestyrer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:42:32.503Z",
    RetteInit: "jca",
  },
  {
    Id: "6543E4D4-4414-490D-8E86-2941B8E9D49E",
    TitelNr: 492,
    Titel: "Recep",
    Navn: "Receptionist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:08:57.083Z",
    RetteInit: "jca",
  },
  {
    Id: "08479C91-6D15-44A9-BCCB-2A353B12C713",
    TitelNr: 102,
    Titel: "Cand.polit",
    Navn: "Cand.polit",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:45:44.960Z",
    RetteInit: "jca",
  },
  {
    Id: "3B2E0566-9580-4BCF-B756-2AE23BD7FEC4",
    TitelNr: 144,
    Titel: "Direktør",
    Navn: "Direktør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:48:58.777Z",
    RetteInit: "jca",
  },
  {
    Id: "8ACF2DB1-68D2-49BD-8915-2B1231C7890E",
    TitelNr: 190,
    Titel: "Forbrugero",
    Navn: "Forbrugerombudsmand",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:59.630Z",
    RetteInit: "jca",
  },
  {
    Id: "427B9760-0626-48D9-8FD7-2C814BC4E50D",
    TitelNr: 1354,
    Titel: "DIKIGOROS",
    Navn: "Dikigoros (græsk advokat)",
    FalId: "29FC87D6-F0EF-4C9E-BDB1-7E2231416B75",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2018-09-14T13:23:05.557Z",
    OpretInit: "the",
    RetteDato: "2022-11-14T08:30:37.823Z",
    RetteInit: "lra",
  },
  {
    Id: "30D2F222-8C3B-422A-8112-2D225CEEA0DD",
    TitelNr: 387,
    Titel: "LL.M., Att",
    Navn: "LL.M., Attorney at law",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:23.527Z",
    RetteInit: "jca",
  },
  {
    Id: "07A2E617-7E3E-46F9-A1FB-2D36339DB459",
    TitelNr: 33,
    Titel: "Afdelingsd",
    Navn: "Afdelingsdirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:40:46.670Z",
    RetteInit: "jca",
  },
  {
    Id: "0226C591-F374-4629-BD34-2DFA5DCB460B",
    TitelNr: 303,
    Titel: "Juridisk r",
    Navn: "Juridisk rådgiver",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:18.437Z",
    RetteInit: "jca",
  },
  {
    Id: "BED3A7D0-2F47-4382-B8A1-2FF2C14E9009",
    TitelNr: 217,
    Titel: "Generalsek",
    Navn: "Generalsekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:54:01.280Z",
    RetteInit: "jca",
  },
  {
    Id: "693611EF-3B15-461F-BEFE-3125DDE53555",
    TitelNr: 34,
    Titel: "Afdelingsl",
    Navn: "Afdelingsleder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:40:50.460Z",
    RetteInit: "jca",
  },
  {
    Id: "83D06340-CAC8-4FE6-AACE-338833F8BBC7",
    TitelNr: 210,
    Titel: "Funktionsc",
    Navn: "Funktionschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:33.073Z",
    RetteInit: "jca",
  },
  {
    Id: "5C709048-A627-4521-B3FD-33CC9FD2F1F8",
    TitelNr: 112,
    Titel: "Chefkonsul",
    Navn: "Chefkonsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:46:28.220Z",
    RetteInit: "jca",
  },
  {
    Id: "6348F3E2-1E06-4522-BA50-340CCF590A92",
    TitelNr: 252,
    Titel: "HR-direktø",
    Navn: "HR-direktør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:31.133Z",
    RetteInit: "jca",
  },
  {
    Id: "ECC2ABA9-A0BF-4272-B9C9-34635D7FBDFD",
    TitelNr: 328,
    Titel: "kontorchef",
    Navn: "Kontorchef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:57:07.187Z",
    RetteInit: "jca",
  },
  {
    Id: "EA39F43F-FA78-4E4A-844F-34F2AEDE28A6",
    TitelNr: 1353,
    Titel: "BOBEHANDLE",
    Navn: "Bobehandler",
    FalId: null,
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2016-04-06T13:46:28.313Z",
    OpretInit: "the",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "3548D03C-D445-4B76-AB2C-352D1DA22C3C",
    TitelNr: 164,
    Titel: "Ejendomsmæ",
    Navn: "Ejendomsmægler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:27.323Z",
    RetteInit: "jca",
  },
  {
    Id: "09D7A619-9C80-439E-B8EA-3644B929EEB9",
    TitelNr: 281,
    Titel: "IT-koor",
    Navn: "IT-koordinator",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:55.443Z",
    RetteInit: "jca",
  },
  {
    Id: "5E6C8DCE-2427-4F15-AB65-372341B005DA",
    TitelNr: 295,
    Titel: "Jur.sek.",
    Navn: "Juridisk sekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:25.597Z",
    RetteInit: "jca",
  },
  {
    Id: "F82365AF-16B2-48A9-B89A-373A7D1287B1",
    TitelNr: 350,
    Titel: "Landsdomme",
    Navn: "Landsdommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:58:48.837Z",
    RetteInit: "jca",
  },
  {
    Id: "D78648A2-2121-4DB4-9421-3752AEE035B3",
    TitelNr: 564,
    Titel: "Seniorrådg",
    Navn: "Senior juridisk rådgiver",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:12:54.643Z",
    RetteInit: "jca",
  },
  {
    Id: "0D7E0AA4-9CEA-42B9-8105-37EB91AB0BBE",
    TitelNr: 253,
    Titel: "HR-konsul",
    Navn: "HR-konsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:35.003Z",
    RetteInit: "jca",
  },
  {
    Id: "67531361-A4D4-4DC3-BD76-37F99716656B",
    TitelNr: 10,
    Titel: "Adm.dommer",
    Navn: "Adm. dommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:19.247Z",
    RetteInit: "jca",
  },
  {
    Id: "AEDF4AA6-5E11-4E0F-A0B5-385366225DC4",
    TitelNr: 1360,
    Titel: "MASTERIR ",
    Navn: "Master of International Relations, (M.I.R)",
    FalId: null,
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 1,
    OpretDato: "2021-05-04T12:44:52.087Z",
    OpretInit: "lra",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "3E48A207-BA32-42E1-AAE9-3A19EFE3487B",
    TitelNr: 663,
    Titel: "BA.JUR.",
    Navn: "BA.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-09-03T12:54:17.630Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:42:43.547Z",
    RetteInit: "jca",
  },
  {
    Id: "249D8055-085B-434C-AE1C-3AA84CBEC79C",
    TitelNr: 188,
    Titel: "fm",
    Navn: "Fuldmægtig, cand.merc.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:28.770Z",
    RetteInit: "jca",
  },
  {
    Id: "B68A4ADE-A8A7-42CD-98CB-3BCBD49F18F0",
    TitelNr: 7,
    Titel: "Adjunkt, p",
    Navn: "Adjunkt, ph.d.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:07.530Z",
    RetteInit: "jca",
  },
  {
    Id: "F48AEFC4-8449-43B1-9C60-3BD99629A655",
    TitelNr: 515,
    Titel: "Retoriker",
    Navn: "Retoriker",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:12.183Z",
    RetteInit: "jca",
  },
  {
    Id: "AD8C9CEF-28C7-48A0-BFCB-3D6A83FF4023",
    TitelNr: 90,
    Titel: "cand.",
    Navn: "Cand.merc.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:45:34.897Z",
    RetteInit: "jca",
  },
  {
    Id: "BAA3C884-F13D-4CBF-A394-3DE6A9607DDA",
    TitelNr: 228,
    Titel: "H.D. (fina",
    Navn: "H.D. (finansiering og kreditvæsen)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:54:40.887Z",
    RetteInit: "jca",
  },
  {
    Id: "2DA424F4-C830-4AC7-8605-3EA47B27411D",
    TitelNr: 98,
    Titel: "cand.m.r.",
    Navn: "Cand.merc.rev",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2022-06-27T12:12:57.363Z",
    RetteInit: "lra",
  },
  {
    Id: "A198CD45-D82B-41C2-9A5F-3EE66AEF55CE",
    TitelNr: 6,
    Titel: "Adjunkt",
    Navn: "Adjunkt",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:02.180Z",
    RetteInit: "jca",
  },
  {
    Id: "F0AF404C-5B68-4C34-B447-3F94C6B8B574",
    TitelNr: 516,
    Titel: "Retsass",
    Navn: "Retsassessor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:15.897Z",
    RetteInit: "jca",
  },
  {
    Id: "7425C4A9-995A-485E-99B6-418F9627DE1C",
    TitelNr: 108,
    Titel: "CEO",
    Navn: "CEO",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:46:11.170Z",
    RetteInit: "jca",
  },
  {
    Id: "0BD44FB0-93CD-4FAF-B3C0-42DE45EF06ED",
    TitelNr: 153,
    Titel: "domfm",
    Navn: "Dommerfuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:49:35.780Z",
    RetteInit: "jca",
  },
  {
    Id: "BD3AC9C5-7108-4E19-9B15-44022EEE2D68",
    TitelNr: 16,
    Titel: "Adviser",
    Navn: "Adviser",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:46.017Z",
    RetteInit: "jca",
  },
  {
    Id: "B15B85A4-E3DD-4A87-AEBE-4570BFDDD851",
    TitelNr: 577,
    Titel: "Skibsfører",
    Navn: "Skibsfører, Søretskonsulent.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:14:23.843Z",
    RetteInit: "jca",
  },
  {
    Id: "5AD75040-9421-4E86-A554-468096F276BB",
    TitelNr: 189,
    Titel: "Fm, cand.j",
    Navn: "Fuldmægtig, cand.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:23.807Z",
    RetteInit: "jca",
  },
  {
    Id: "1C59AEDD-4C80-4624-AA22-4974CD2AD88B",
    TitelNr: 234,
    Titel: "HD",
    Navn: "HD",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:13.057Z",
    RetteInit: "jca",
  },
  {
    Id: "365FFDEF-77FD-4E0A-BE71-498FF848F66D",
    TitelNr: 319,
    Titel: "Koncernadv",
    Navn: "Koncernadvokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:27.263Z",
    RetteInit: "jca",
  },
  {
    Id: "9D544F77-B07A-46E5-B26B-4A133536C3D5",
    TitelNr: 211,
    Titel: "Funktionsl",
    Navn: "Funktionsleder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:36.787Z",
    RetteInit: "jca",
  },
  {
    Id: "EF10F327-1544-487F-A8A3-4B7854425923",
    TitelNr: 354,
    Titel: "Landsretss",
    Navn: "Landsretssagfører",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "A08C43E5-62DB-4338-A62D-4D95FC07F482",
    TitelNr: 289,
    Titel: "Jur. dir.",
    Navn: "Jur. dir.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:28.733Z",
    RetteInit: "jca",
  },
  {
    Id: "A76BFFC8-5EB4-409C-9597-4F0D4B836053",
    TitelNr: 355,
    Titel: "Lawyer",
    Navn: "Lawyer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "AA048967-A992-452E-ABAA-50DAB6B09C27",
    TitelNr: 368,
    Titel: "Lektor, ca",
    Navn: "Lektor, cand. jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "1FC7212D-416D-4CAF-B9C9-513C46DF20D2",
    TitelNr: 301,
    Titel: "juridisk k",
    Navn: "Juridisk konsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:07.937Z",
    RetteInit: "jca",
  },
  {
    Id: "5D198F33-9B1E-429F-99D5-558C81CCA483",
    TitelNr: 97,
    Titel: "cand.m.a.",
    Navn: "Cand.merc.aud",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2022-06-27T12:09:30.573Z",
    RetteInit: "lra",
  },
  {
    Id: "577057AE-9978-401A-AFE9-586119BD7552",
    TitelNr: 181,
    Titel: "Fast medhj",
    Navn: "Fast medhjælper v. Sø-Handelsretten",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:30.563Z",
    RetteInit: "jca",
  },
  {
    Id: "78BD251B-895F-4F1D-95EE-599292D69F72",
    TitelNr: 379,
    Titel: "LL.M. & So",
    Navn: "LL.M. & Solicitor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:00:53.417Z",
    RetteInit: "jca",
  },
  {
    Id: "0E4CA4BB-750E-4527-A180-599FB16CED08",
    TitelNr: 582,
    Titel: "Solicitor ",
    Navn: "Solicitor",
    FalId: "E0E8FD63-A007-4F8D-8A7E-E4FC71373A1D",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:12:18.287Z",
    RetteInit: "jca",
  },
  {
    Id: "C448757A-FBCA-4291-9DEA-5A1B9B2C7D66",
    TitelNr: 347,
    Titel: "Kursuslekt",
    Navn: "Kursuslektor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:58:37.930Z",
    RetteInit: "jca",
  },
  {
    Id: "09D9E757-5F86-4EDA-810A-5A7117068916",
    TitelNr: 71,
    Titel: "Bobestyrer",
    Navn: "Bobestyrer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:43:27.367Z",
    RetteInit: "jca",
  },
  {
    Id: "766DBA39-37EF-4EFA-B6EF-5C0CED9C563C",
    TitelNr: 291,
    Titel: "Jur.dir",
    Navn: "Juridisk Direktør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:57.173Z",
    RetteInit: "jca",
  },
  {
    Id: "10FDBDE6-EA14-4CCA-BCA6-5C3C7606DA00",
    TitelNr: 420,
    Titel: "Member of ",
    Navn: "Member of the Law Society - England & Wales",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:52.570Z",
    RetteInit: "jca",
  },
  {
    Id: "B840CE38-2C8F-44A6-8992-5D73C7160B84",
    TitelNr: 600,
    Titel: "Statsaut.r",
    Navn: "Statsaut. revisor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:16:19.537Z",
    RetteInit: "jca",
  },
  {
    Id: "0654F029-3DB2-4DDD-83AC-5D74E4ABC22C",
    TitelNr: 128,
    Titel: "Corpo advi",
    Navn: "Corporate Advisor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:42.490Z",
    RetteInit: "jca",
  },
  {
    Id: "4BF29EC5-4CF2-44A3-87F2-604159FC23A6",
    TitelNr: 519,
    Titel: "Retspræ",
    Navn: "Retspræsident",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:27.563Z",
    RetteInit: "jca",
  },
  {
    Id: "EB63875D-5A7D-45E0-AC89-6060AFCFCAEC",
    TitelNr: 152,
    Titel: "Documenta",
    Navn: "Documentation Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:49:29.383Z",
    RetteInit: "jca",
  },
  {
    Id: "E1E771FF-8431-4CB5-9F03-61982896DE71",
    TitelNr: 183,
    Titel: "FD",
    Navn: "FD",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:39.020Z",
    RetteInit: "jca",
  },
  {
    Id: "46D635E7-7233-4ACF-B965-62943610DFF5",
    TitelNr: 195,
    Titel: "Formand",
    Navn: "Formand",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:52:17.133Z",
    RetteInit: "jca",
  },
  {
    Id: "B7D54912-1FF7-40B5-BD69-638C0707A498",
    TitelNr: 84,
    Titel: "Bygnings i",
    Navn: "Bygnings ing.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:44:27.537Z",
    RetteInit: "jca",
  },
  {
    Id: "0659D522-15A8-4F62-B37B-63EBB61B02D8",
    TitelNr: 208,
    Titel: "Fr.",
    Navn: "Fr.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:15.650Z",
    RetteInit: "jca",
  },
  {
    Id: "EECC37E5-B01A-4D61-9741-655C3D649F50",
    TitelNr: 356,
    Titel: "leasing",
    Navn: "Leasingkonsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:59:22.750Z",
    RetteInit: "jca",
  },
  {
    Id: "C24A108B-628D-453E-B7CF-6726883CD685",
    TitelNr: 72,
    Titel: "Bogholder",
    Navn: "Bogholder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:43:30.567Z",
    RetteInit: "jca",
  },
  {
    Id: "7877D67D-4F20-4631-8490-674D03F49FD5",
    TitelNr: 585,
    Titel: "soucchef",
    Navn: "Souschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:15:23.623Z",
    RetteInit: "jca",
  },
  {
    Id: "BF0520BC-720B-47C0-980C-6870596F214B",
    TitelNr: 24,
    Titel: "Advokat LL",
    Navn: "Advokat LL.M.",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:01:45.753Z",
    RetteInit: "jca",
  },
  {
    Id: "49F287E6-8C31-4D7D-B08B-6938B4D91D21",
    TitelNr: 156,
    Titel: "Dr.jur.",
    Navn: "Dr.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "915CB2CF-7143-4DFC-A771-6AA11F61FF0B",
    TitelNr: 401,
    Titel: "M.C.L., og",
    Navn: "M.C.L., og ekstern lektor i konkurrenceret",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:22.807Z",
    RetteInit: "jca",
  },
  {
    Id: "678E4FD7-BC52-4AA6-B431-6B5A0EC94375",
    TitelNr: 402,
    Titel: "M.F.",
    Navn: "Medlem af Folketinget",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:25.753Z",
    RetteInit: "jca",
  },
  {
    Id: "BDE0CE64-793C-4F77-A909-6B943CA7D2E3",
    TitelNr: 307,
    Titel: "Jusmin",
    Navn: "Justitsminister",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:47.640Z",
    RetteInit: "jca",
  },
  {
    Id: "F7CA3D41-D6FF-46B4-97F4-6CB5DE77D404",
    TitelNr: 625,
    Titel: "Translatør",
    Navn: "Translatør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:18:03.977Z",
    RetteInit: "jca",
  },
  {
    Id: "156A10B7-F934-4B44-8949-6E7076FEA07B",
    TitelNr: 1362,
    Titel: "ADVOKATAS",
    Navn: "Advokatas",
    FalId: "789DD4F0-EA81-449F-AE5F-ADD699A90A62",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2021-11-26T12:36:14.750Z",
    OpretInit: "lra",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "5DAA153A-819A-4540-AFDD-6F0D3FA4CCA9",
    TitelNr: 27,
    Titel: "Advokat, m",
    Navn: "Advokat, mf",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-03-17T23:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "8754C47A-446C-48CE-B9F4-72397A728DFE",
    TitelNr: 280,
    Titel: "IT-konsule",
    Navn: "IT-konsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:52.260Z",
    RetteInit: "jca",
  },
  {
    Id: "711FEE46-7F4F-4E49-A7EF-73525A560352",
    TitelNr: 261,
    Titel: "info.råd",
    Navn: "Informationsrådgiver",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:52:14.780Z",
    RetteInit: "jca",
  },
  {
    Id: "2A5ABAD0-3486-4FCE-9E9C-73FF27C599EC",
    TitelNr: 329,
    Titel: "kontorfuld",
    Navn: "Kontorfuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:57:25.280Z",
    RetteInit: "jca",
  },
  {
    Id: "33652983-16D0-41BB-84CF-753D6280EE40",
    TitelNr: 578,
    Titel: "Skifterets",
    Navn: "Skifteretsmedhjælper i Gældssaneringssager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:14:27.417Z",
    RetteInit: "jca",
  },
  {
    Id: "2559C1A1-554F-4247-9B80-75B42DFC2278",
    TitelNr: 202,
    Titel: "Forsuppor",
    Navn: "Forretningssupportchef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:52:23.480Z",
    RetteInit: "jca",
  },
  {
    Id: "9A45C48A-2F4A-4FA2-A251-7607620500D8",
    TitelNr: 411,
    Titel: "MBA",
    Navn: "MBA",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:53.943Z",
    RetteInit: "jca",
  },
  {
    Id: "7D34ECD3-8190-41EC-906C-76BE0D753296",
    TitelNr: 1352,
    Titel: "ØDI",
    Navn: "Økonomidirektør",
    FalId: null,
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2014-01-07T12:44:04.310Z",
    OpretInit: "the",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "D2E9EDEA-2578-4CEF-BE3D-76EB0492FD9F",
    TitelNr: 405,
    Titel: "Manager",
    Navn: "Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:30.840Z",
    RetteInit: "jca",
  },
  {
    Id: "A61E2475-CBAB-4563-92BA-77E024DEDCFF",
    TitelNr: 662,
    Titel: "ADVOCAAT",
    Navn: "Advocaat",
    FalId: "63872BF5-AEFB-4705-A06E-090C590F2536",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-06-09T09:06:08.960Z",
    OpretInit: "bth",
    RetteDato: "2011-04-08T13:01:14.380Z",
    RetteInit: "jca",
  },
  {
    Id: "E198E80C-DBF4-4CA2-91EE-78BD1E20C850",
    TitelNr: 63,
    Titel: "Avvocato",
    Navn: "Avvocato",
    FalId: "4B1FB705-A940-4E38-9CDD-A6C2DA2A2218",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:06:14.083Z",
    RetteInit: "jca",
  },
  {
    Id: "34772413-5757-4C7E-AC00-792C8C52A8CF",
    TitelNr: 1358,
    Titel: "BARRISTER",
    Navn: "Barrister",
    FalId: null,
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2019-09-04T09:11:15.250Z",
    OpretInit: "bth",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "D034C6E2-642C-4913-9D8E-79DF5FAC8D76",
    TitelNr: 99,
    Titel: "Cand.mag.",
    Navn: "Cand. mag.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:44:48.410Z",
    RetteInit: "jca",
  },
  {
    Id: "F9B2362A-4A7A-4581-869C-7B26E682144D",
    TitelNr: 1361,
    Titel: "ASIANAJAJA",
    Navn: "Asianajaja",
    FalId: "799F0A03-D5DD-40FE-A868-06F4D6CCB9D5",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2021-10-06T06:09:55.080Z",
    OpretInit: "lra",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "EE41265D-F65B-4777-8769-7B2A3553E7DD",
    TitelNr: 60,
    Titel: "Avocat",
    Navn: "Avocat",
    FalId: "763488A7-D1F2-47FE-BE08-43A7070AA8AA",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:04:47.097Z",
    RetteInit: "jca",
  },
  {
    Id: "92BAE208-D67F-48B7-AD23-7DB463B4D5D3",
    TitelNr: 400,
    Titel: "M.C.L.",
    Navn: "M.C.L.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:18.017Z",
    RetteInit: "jca",
  },
  {
    Id: "F388728C-A00F-4977-B97D-7ED425B6EEEA",
    TitelNr: 185,
    Titel: "Fhv.lands",
    Navn: "Fhv. Landsdommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:47.460Z",
    RetteInit: "jca",
  },
  {
    Id: "A792B91B-E171-49AA-8E07-7FC498B801C5",
    TitelNr: 147,
    Titel: "Dispachør",
    Navn: "Dispachør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:49:15.623Z",
    RetteInit: "jca",
  },
  {
    Id: "21A0584F-4E99-4880-BE95-8135C2AE716C",
    TitelNr: 596,
    Titel: "Statsadvas",
    Navn: "Statsadvokatassesor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:16:02.297Z",
    RetteInit: "jca",
  },
  {
    Id: "EC9BDCD3-DF52-46F4-918E-81890797C5DB",
    TitelNr: 667,
    Titel: "CHEFKCANDJ",
    Navn: "Chefkonsulent, cand.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-11-20T08:22:09.083Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:46:32.400Z",
    RetteInit: "jca",
  },
  {
    Id: "ECE6C1D9-8A85-4CEA-9637-81A817B5493A",
    TitelNr: 101,
    Titel: "cand.merc.",
    Navn: "Cand.merc.jur",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:45:41.870Z",
    RetteInit: "jca",
  },
  {
    Id: "AAB1C909-A7A5-46F3-89B0-81DC942303CF",
    TitelNr: 495,
    Titel: "Rechtsanw",
    Navn: "Rechtsanwalt",
    FalId: "21467684-B8F5-4F93-9F6D-298B1302687B",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:10:50.363Z",
    RetteInit: "jca",
  },
  {
    Id: "2B10BF37-92C2-40A3-A4AC-821D6B121D50",
    TitelNr: 413,
    Titel: "MCJ (Maste",
    Navn: "MCJ (Master of Comparative Jurisprudence)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:01.150Z",
    RetteInit: "jca",
  },
  {
    Id: "92F74330-2E3C-459A-9EC5-82A8E8C0AE78",
    TitelNr: 222,
    Titel: "Group Con",
    Navn: "Group Controller",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:54:17.737Z",
    RetteInit: "jca",
  },
  {
    Id: "0ABB237C-5EF2-4D50-B1FA-837327ABBDC1",
    TitelNr: 203,
    Titel: "Forsvarsad",
    Navn: "Forsvarsadvokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:52:42.263Z",
    RetteInit: "jca",
  },
  {
    Id: "AB5EE308-671F-4101-955F-83CFB102BF94",
    TitelNr: 238,
    Titel: "HD (Finans",
    Navn: "HD (Finansiering)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:29.827Z",
    RetteInit: "jca",
  },
  {
    Id: "3854C361-E339-4488-B0DC-84884A768B2E",
    TitelNr: 417,
    Titel: "mediator m",
    Navn: "mediator m.m.c.r",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:17.640Z",
    RetteInit: "jca",
  },
  {
    Id: "AB3D21AF-D00E-4D3B-B922-85D48E9C13B3",
    TitelNr: 523,
    Titel: "Revisor",
    Navn: "Revisor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:42.650Z",
    RetteInit: "jca",
  },
  {
    Id: "3E95F71B-4889-4425-B64B-879D03ACB732",
    TitelNr: 19,
    Titel: "Advokat ( ",
    Navn: "Advokat ( Danmark )",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:01:32.160Z",
    RetteInit: "jca",
  },
  {
    Id: "9CBA92E6-C699-4946-9835-87F017EA794C",
    TitelNr: 324,
    Titel: "Konfliktmæ",
    Navn: "Konfliktmægler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:50.773Z",
    RetteInit: "jca",
  },
  {
    Id: "DC890FFC-4963-4E48-85FF-88EC802695BC",
    TitelNr: 21,
    Titel: "Advokat (L",
    Navn: "Advokat(L)",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:02:08.050Z",
    RetteInit: "jca",
  },
  {
    Id: "FF2ABAC0-DB14-4125-9D9E-8AFCEB8296ED",
    TitelNr: 497,
    Titel: "Rechtsanwä",
    Navn: "Rechtsanwältin",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "63381562-C4B8-4EE5-B541-8B7304CD28E7",
    TitelNr: 357,
    Titel: "Leder",
    Navn: "Leder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:59:26.510Z",
    RetteInit: "jca",
  },
  {
    Id: "8AB52C82-5FD4-42F3-935E-8BF214825785",
    TitelNr: 382,
    Titel: "LL.M. MBA",
    Navn: "LL.M. MBA",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:04.667Z",
    RetteInit: "jca",
  },
  {
    Id: "AC76AC83-708E-417D-92E8-8CCC6B1573E3",
    TitelNr: 315,
    Titel: "Kommunaldi",
    Navn: "Kommunaldirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:15.063Z",
    RetteInit: "jca",
  },
  {
    Id: "4B7F18B7-C5EB-49F6-AF07-8D4C1A9D57B1",
    TitelNr: 388,
    Titel: "LL.M., Eks",
    Navn: "LL.M., Ekstern Lektor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:26.757Z",
    RetteInit: "jca",
  },
  {
    Id: "A06D6CF9-E924-46A9-9044-8DDB915B587B",
    TitelNr: 125,
    Titel: "Controller",
    Navn: "Controller",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:39.230Z",
    RetteInit: "jca",
  },
  {
    Id: "5A6497E5-37D3-4FCD-9635-90CB6BF6B794",
    TitelNr: 590,
    Titel: "Specialkon",
    Navn: "Specialkonsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:15:33.903Z",
    RetteInit: "jca",
  },
  {
    Id: "A968D2F4-F44B-42F8-87E0-956CBDA9AA76",
    TitelNr: 461,
    Titel: "Ph.D.",
    Navn: "Ph.D.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:06:39.273Z",
    RetteInit: "jca",
  },
  {
    Id: "E3B4BF5F-268F-4A3B-87DB-965CFF4338EF",
    TitelNr: 233,
    Titel: "HA-jur",
    Navn: "HA-jur",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:09.733Z",
    RetteInit: "jca",
  },
  {
    Id: "7780BC05-9B25-4D95-80D8-969473010F03",
    TitelNr: 279,
    Titel: "IT-chef",
    Navn: "IT-chef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:48.517Z",
    RetteInit: "jca",
  },
  {
    Id: "D16DB93C-1045-418D-BA93-982F9D37F4F9",
    TitelNr: 389,
    Titel: "LL.M., Sol",
    Navn: "LL.M., Solicitor (Englund & Wales)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:30.513Z",
    RetteInit: "jca",
  },
  {
    Id: "3DA1B9FA-AA1A-406D-BF0F-994017275FED",
    TitelNr: 487,
    Titel: "Prokurist",
    Navn: "Prokurist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:08:27.820Z",
    RetteInit: "jca",
  },
  {
    Id: "64770DAF-8881-48C5-878E-9A989FC35E1F",
    TitelNr: 477,
    Titel: "Prof.dr.ju",
    Navn: "Professor, dr.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "FD82C1EC-37E4-4C4C-A4B6-9AC8E8D03AE4",
    TitelNr: 648,
    Titel: "Vicestatsa",
    Navn: "Vicestatsadvokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:19:40.607Z",
    RetteInit: "jca",
  },
  {
    Id: "0E3A3B29-72FA-4AC9-BBF2-9BBE0891F269",
    TitelNr: 93,
    Titel: "Cand.jur.",
    Navn: "Cand.jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:45:19.593Z",
    RetteInit: "jca",
  },
  {
    Id: "808D9B95-ACAA-4B29-B0F5-9BC7D8C0C457",
    TitelNr: 216,
    Titel: "General ma",
    Navn: "General Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:56.473Z",
    RetteInit: "jca",
  },
  {
    Id: "34EB7FB9-0AD0-4A6E-8B24-9C79C95E70EB",
    TitelNr: 28,
    Titel: "Advokat, u",
    Navn: "Advokat, underdirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-03-17T23:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "ECB179B0-A323-4B93-B635-9DC2E53F096D",
    TitelNr: 62,
    Titel: "Avocate",
    Navn: "Avocate",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-03-17T23:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "BF187B22-E0FE-4C5C-A3D8-9E03898ACDF4",
    TitelNr: 520,
    Titel: "Retspræs",
    Navn: "Retspræsident",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:31.107Z",
    RetteInit: "jca",
  },
  {
    Id: "5E38248D-FBF9-491B-9487-9E745A660C57",
    TitelNr: 365,
    Titel: "Lektor",
    Navn: "Lektor",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:59:59.567Z",
    RetteInit: "jca",
  },
  {
    Id: "0D4774F0-1F59-4C56-9E3F-9EED50221530",
    TitelNr: 416,
    Titel: "Mediator",
    Navn: "Mediator",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:11.447Z",
    RetteInit: "jca",
  },
  {
    Id: "55DB009B-CC48-445B-AAE2-A12EC1D32485",
    TitelNr: 56,
    Titel: "Aut. bobes",
    Navn: "Aut. bobestyrer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:42:21.363Z",
    RetteInit: "jca",
  },
  {
    Id: "E1DB4070-0B24-4182-AEF5-A13539CF843E",
    TitelNr: 166,
    Titel: "Ekspeditio",
    Navn: "Ekspeditionssekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:34.403Z",
    RetteInit: "jca",
  },
  {
    Id: "F869A844-CE90-40B5-AFD6-A2CC3992D8E0",
    TitelNr: 381,
    Titel: "LL.M. Aut.",
    Navn: "LL.M. Aut. bobestyrer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:00.547Z",
    RetteInit: "jca",
  },
  {
    Id: "EE778734-C935-4FD3-A2FE-A32D5ABA367F",
    TitelNr: 300,
    Titel: "Juridisk f",
    Navn: "Juridisk fuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:04.787Z",
    RetteInit: "jca",
  },
  {
    Id: "D3F64295-35DF-4681-A62C-A516A28A2111",
    TitelNr: 352,
    Titel: "Landsret",
    Navn: "Landsretspræsident",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:59:17.603Z",
    RetteInit: "jca",
  },
  {
    Id: "A4115BFF-5EE4-4047-A683-A6B88DA0DDDF",
    TitelNr: 106,
    Titel: "Cand.scien",
    Navn: "Cand.scient.pol.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:46:02.540Z",
    RetteInit: "jca",
  },
  {
    Id: "A115C493-1302-4A40-ABF1-A73865469CCB",
    TitelNr: 298,
    Titel: "Juridisk b",
    Navn: "Juridisk sagsbehandler",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:22.397Z",
    RetteInit: "jca",
  },
  {
    Id: "ED676BEC-AE0D-4014-BC2A-A84608704598",
    TitelNr: 493,
    Titel: "Rechtanwal",
    Navn: "Rechtanwaltin",
    FalId: "21467684-B8F5-4F93-9F6D-298B1302687B",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:10:40.707Z",
    RetteInit: "jca",
  },
  {
    Id: "6CA61D43-AE3E-42FC-865B-A91271330D4E",
    TitelNr: 256,
    Titel: "Højeste",
    Navn: "Højesteretsdommer",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:40.043Z",
    RetteInit: "jca",
  },
  {
    Id: "A87693C8-7172-4FC2-B9E0-A923EB63916E",
    TitelNr: 282,
    Titel: "IT-medarbe",
    Navn: "IT-medarbejder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:58.923Z",
    RetteInit: "jca",
  },
  {
    Id: "5D446CEB-3176-4ACE-8D8E-A9C0A8BCC98C",
    TitelNr: 588,
    Titel: "Specialfag",
    Navn: "Specialfagseksamen i Søret, Pilot",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:15:27.307Z",
    RetteInit: "jca",
  },
  {
    Id: "791BF0C8-189B-44CA-B611-AA3715B009C3",
    TitelNr: 377,
    Titel: "LL.M",
    Navn: "LL.M",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:00:45.227Z",
    RetteInit: "jca",
  },
  {
    Id: "1EE54BA7-C99E-475E-B6D1-ABB298F774F7",
    TitelNr: 287,
    Titel: "journalist",
    Navn: "Journalist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:54:13.587Z",
    RetteInit: "jca",
  },
  {
    Id: "F1A40502-6EC9-4FB4-83A2-AC7490BE18FF",
    TitelNr: 386,
    Titel: "LL.M., ACI",
    Navn: "LL.M., ACIARB.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:18.613Z",
    RetteInit: "jca",
  },
  {
    Id: "FD285806-D889-4C03-9B74-AD86AB91940F",
    TitelNr: 254,
    Titel: "Hr.",
    Navn: "Hr.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:09.090Z",
    RetteInit: "jca",
  },
  {
    Id: "798D8544-ED7E-4ACE-A12D-AFB6604E6288",
    TitelNr: 642,
    Titel: "Vicepoliti",
    Navn: "Vicepolitimester",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:19:16.363Z",
    RetteInit: "jca",
  },
  {
    Id: "FBF304F9-FF54-4FB7-8E90-B17636D13D0A",
    TitelNr: 438,
    Titel: "Ordførende",
    Navn: "Ordførende Direktør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:05:11.257Z",
    RetteInit: "jca",
  },
  {
    Id: "8CC1E6E4-63CD-423E-8E21-B2023E3429B9",
    TitelNr: 174,
    Titel: "Etablering",
    Navn: "Etableringsvejleder",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:56.573Z",
    RetteInit: "jca",
  },
  {
    Id: "0DE52B1F-3EEB-42DF-B9FD-B40B365C189B",
    TitelNr: 412,
    Titel: "MBA, HD",
    Navn: "MBA, HD",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:57.393Z",
    RetteInit: "jca",
  },
  {
    Id: "5DF6AE4F-CF85-4E7D-A8CA-B4E8C91B377E",
    TitelNr: 235,
    Titel: "HD (F)",
    Navn: "HD (F)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:18.140Z",
    RetteInit: "jca",
  },
  {
    Id: "FE922115-CC08-44F7-BBEA-B59C5A6EEC8A",
    TitelNr: 141,
    Titel: "Dir.sek.",
    Navn: "Direktionssekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:48:52.083Z",
    RetteInit: "jca",
  },
  {
    Id: "19D54592-1D9E-4344-B8E4-B5EFCD371C0F",
    TitelNr: 306,
    Titel: "Jurist",
    Navn: "Jurist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:35.220Z",
    RetteInit: "jca",
  },
  {
    Id: "9E79A951-0391-43B5-B009-B5F0465D6FC0",
    TitelNr: 31,
    Titel: "Advosek",
    Navn: "Advokatsekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:40:29.307Z",
    RetteInit: "jca",
  },
  {
    Id: "782854EA-8DC0-498A-BF0F-B69FDC82EEA7",
    TitelNr: 257,
    Titel: "Højesteret",
    Navn: "Højesteretssagfører",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:46.767Z",
    RetteInit: "jca",
  },
  {
    Id: "D2075D3E-ABD3-4FB0-8A71-B7C9C5D7BF9D",
    TitelNr: 450,
    Titel: "Partner",
    Navn: "Partner",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:06:07.747Z",
    RetteInit: "jca",
  },
  {
    Id: "2012330D-D21B-444E-8DCE-B81E00C35E39",
    TitelNr: 1351,
    Titel: "LDI",
    Navn: "Legal Director",
    FalId: null,
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2014-01-02T10:30:50.867Z",
    OpretInit: "the",
    RetteDato: "1752-12-31T23:00:00.000Z",
    RetteInit: null,
  },
  {
    Id: "95A2F201-92B6-4CCC-8BE5-BC71081EBEEC",
    TitelNr: 130,
    Titel: "D.A.E.S.(D",
    Navn: "D.A.E.S.(Diploma of Advanced European Studies)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:48:06.860Z",
    RetteInit: "jca",
  },
  {
    Id: "4D49D7E1-095C-42D1-BE2C-BCE048CF3BD9",
    TitelNr: 25,
    Titel: "Advokat MB",
    Navn: "Advokat MBA",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:01:53.223Z",
    RetteInit: "jca",
  },
  {
    Id: "FBA3D1D9-4197-4A74-B0CE-BCED84F4A268",
    TitelNr: 670,
    Titel: "SIVILOMBUD",
    Navn: "Sivilombudsmann",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2009-03-20T10:45:58.787Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:13:50.740Z",
    RetteInit: "jca",
  },
  {
    Id: "D8C586FD-766E-4C3B-B65A-BD2F6317DB4D",
    TitelNr: 179,
    Titel: "faglig kon",
    Navn: "Faglig konsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:13.890Z",
    RetteInit: "jca",
  },
  {
    Id: "A2C4B593-4CAB-451F-A03E-BEE71EBFC10A",
    TitelNr: 333,
    Titel: "Korr",
    Navn: "Korrespondent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:57:41.257Z",
    RetteInit: "jca",
  },
  {
    Id: "BDE389A4-6023-4DCD-9D1B-BF2DBAD1743F",
    TitelNr: 665,
    Titel: "SENIORTAXC",
    Navn: "Senior Tax Consultant",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-09-10T11:03:05.493Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:13:08.467Z",
    RetteInit: "jca",
  },
  {
    Id: "CE527CFF-E089-4059-AED4-BF328DDB84D2",
    TitelNr: 39,
    Titel: "Amtsrådsme",
    Navn: "Amtsrådsmedlem",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:41:08.730Z",
    RetteInit: "jca",
  },
  {
    Id: "B30E3BB3-BB9E-4BF2-A108-BF9F068990D0",
    TitelNr: 373,
    Titel: "Lic.Jur.",
    Navn: "Lic.Jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "037665BF-2984-47FE-8D23-C1AA2ED220D8",
    TitelNr: 313,
    Titel: "Kom chef",
    Navn: "Kommunikationschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:18.527Z",
    RetteInit: "jca",
  },
  {
    Id: "F85005E0-FA74-46CF-A699-C1BF52E63802",
    TitelNr: 26,
    Titel: "Advokat, L",
    Navn: "Advokat, LL.M.",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:02:19.520Z",
    RetteInit: "jca",
  },
  {
    Id: "27A4FE77-6A93-4297-A77E-C2753DE58AAE",
    TitelNr: 378,
    Titel: "LL.M.",
    Navn: "LL.M.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:00:49.143Z",
    RetteInit: "jca",
  },
  {
    Id: "374169D6-AF24-4A0B-B0F9-C28B9CFBC558",
    TitelNr: 249,
    Titel: "HR-ans",
    Navn: "HR-ansvarlig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2019-10-17T12:47:39.527Z",
    RetteInit: "lra",
  },
  {
    Id: "B4404C88-EFB9-4794-A825-C3216D71A88A",
    TitelNr: 237,
    Titel: "HD (F), MB",
    Navn: "HD (F), MBA",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:25.723Z",
    RetteInit: "jca",
  },
  {
    Id: "40B3EEC2-9AD4-446C-9DE2-C39D8354C67E",
    TitelNr: 632,
    Titel: "Underdirek",
    Navn: "Underdirektør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:18:29.983Z",
    RetteInit: "jca",
  },
  {
    Id: "2D19808A-F6E9-410E-9B09-C4493C991BB0",
    TitelNr: 250,
    Titel: "HR-chef",
    Navn: "HR-chef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:56:16.203Z",
    RetteInit: "jca",
  },
  {
    Id: "74B9BA08-533D-4A27-A962-C4AF1D169635",
    TitelNr: 239,
    Titel: "HD (R)",
    Navn: "HD (R)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:33.960Z",
    RetteInit: "jca",
  },
  {
    Id: "45B057B5-92E7-479F-872E-C4D3104B4F22",
    TitelNr: 68,
    Titel: "Beneficere",
    Navn: "Beneficeret",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:43:15.700Z",
    RetteInit: "jca",
  },
  {
    Id: "6386F0AB-DB39-4A4E-BDFA-C5480986721E",
    TitelNr: 286,
    Titel: "Italiensk ",
    Navn: "Italiensk Cand.Jur. (Dottore in Giurisprudenza)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:37.550Z",
    RetteInit: "jca",
  },
  {
    Id: "BC84B3E6-52A5-43F3-A9D2-C6D1882FEF73",
    TitelNr: 549,
    Titel: "Sekretær",
    Navn: "Sekretær",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:12:19.603Z",
    RetteInit: "jca",
  },
  {
    Id: "B31875D5-1109-4296-AA50-C71BA5059D83",
    TitelNr: 172,
    Titel: "erhvervsju",
    Navn: "Erhvervsjurist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:50:48.850Z",
    RetteInit: "jca",
  },
  {
    Id: "A3113653-29CF-443A-B010-C8A6AA9EE0D2",
    TitelNr: 124,
    Titel: "contract m",
    Navn: "Contract Manager",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:35.800Z",
    RetteInit: "jca",
  },
  {
    Id: "2A8C13B9-DFFA-4B4C-B7C7-C8B81ABB651B",
    TitelNr: 8,
    Titel: "Adm. direk",
    Navn: "Adm. direktør",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:14.707Z",
    RetteInit: "jca",
  },
  {
    Id: "E9D168BF-1C66-478E-86D3-C9776AE5D570",
    TitelNr: 20,
    Titel: "Advokat (H",
    Navn: "Advokat(H)",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:02:00.147Z",
    RetteInit: "jca",
  },
  {
    Id: "5A4AC3CD-DF10-43EC-8C46-C9C14C2EC420",
    TitelNr: 374,
    Titel: "Licensed L",
    Navn: "Licensed Legal Consultant, New York",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:00:25.383Z",
    RetteInit: "jca",
  },
  {
    Id: "CCCA95F7-0730-489C-BCDC-CAB4F168F86B",
    TitelNr: 414,
    Titel: "Mcj.",
    Navn: "Mcj.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:03:04.460Z",
    RetteInit: "jca",
  },
  {
    Id: "D6EBDECE-2153-4CFF-931B-CC839C455A30",
    TitelNr: 209,
    Titel: "Fuldmægtig",
    Navn: "Fuldmægtig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:53:19.503Z",
    RetteInit: "jca",
  },
  {
    Id: "4936D11C-46F1-455C-9C95-CE0827F9FDE6",
    TitelNr: 294,
    Titel: "Jur.koor",
    Navn: "Juridisk koordinator",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:55:11.477Z",
    RetteInit: "jca",
  },
  {
    Id: "F16D85ED-D472-4A6E-9041-CEE8CB127FF7",
    TitelNr: 517,
    Titel: "Retschef",
    Navn: "Retschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:20.060Z",
    RetteInit: "jca",
  },
  {
    Id: "6204ABA5-8DAF-4A9B-89A3-D075E3C46775",
    TitelNr: 576,
    Titel: "Skatteråd",
    Navn: "Skatterådgiver",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:14:20.617Z",
    RetteInit: "jca",
  },
  {
    Id: "96B78F2C-06EC-4AF7-87B2-D17C7B0D931C",
    TitelNr: 506,
    Titel: "Regionsråd",
    Navn: "Regionsrådsmedlem",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:09:30.140Z",
    RetteInit: "jca",
  },
  {
    Id: "A77BF47B-CD44-450D-BEFA-D1B4D189CCE4",
    TitelNr: 399,
    Titel: "M.C.J.",
    Navn: "M.C.J.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:14.617Z",
    RetteInit: "jca",
  },
  {
    Id: "519DD16E-93ED-43C0-AEEE-D1FE62F4F77F",
    TitelNr: 392,
    Titel: "LLM, HD",
    Navn: "LLM, HD",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:01:40.797Z",
    RetteInit: "jca",
  },
  {
    Id: "EB56ACB6-C806-47D5-AC6D-D23001E3F039",
    TitelNr: 117,
    Titel: "Cheføkonom",
    Navn: "Cheføkonom",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:11.057Z",
    RetteInit: "jca",
  },
  {
    Id: "825DADF0-082B-46FE-9D1C-D5FCCB59F6A6",
    TitelNr: 155,
    Titel: "Dr. jur.",
    Navn: "Dr. jur.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "A80A5304-075C-46AE-AAAF-D68BDBFAD544",
    TitelNr: 494,
    Titel: "Rechtsan",
    Navn: "Rechtsanwältin",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2008-04-23T22:00:00.000Z",
    RetteInit: "jca",
  },
  {
    Id: "CA8BC0C0-7765-4D14-9103-D6B5C941C3DC",
    TitelNr: 496,
    Titel: "Rechtsanwa",
    Navn: "Rechtsanwalt, LL.M.",
    FalId: "21467684-B8F5-4F93-9F6D-298B1302687B",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-04-08T13:11:07.287Z",
    RetteInit: "jca",
  },
  {
    Id: "48E91E5F-D9BA-4938-AAA7-D7976FCC1FEC",
    TitelNr: 403,
    Titel: "Man.ass",
    Navn: "Management Assistant",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:27.113Z",
    RetteInit: "jca",
  },
  {
    Id: "6300378D-CBAC-4F2F-847E-D7E273C90C58",
    TitelNr: 143,
    Titel: "Direktions",
    Navn: "Direktionsassistent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:48:44.720Z",
    RetteInit: "jca",
  },
  {
    Id: "B49204D3-7717-461D-83D6-DD4A36475696",
    TitelNr: 325,
    Titel: "Konsulent",
    Navn: "Konsulent",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:57.140Z",
    RetteInit: "jca",
  },
  {
    Id: "EFFA8672-9FF5-4955-9FD4-DD4DEE0F5046",
    TitelNr: 12,
    Titel: "Admini",
    Navn: "Administrationschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:29.370Z",
    RetteInit: "jca",
  },
  {
    Id: "96A16235-C307-4D1B-AFAC-DEF5474E8C84",
    TitelNr: 277,
    Titel: "IT-ansvarl",
    Navn: "IT-ansvarlig",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:53:42.213Z",
    RetteInit: "jca",
  },
  {
    Id: "8EDB1C71-440D-47AE-B0A6-E1CB28A5E662",
    TitelNr: 320,
    Titel: "Koncernjur",
    Navn: "Koncernjurist",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:56:34.457Z",
    RetteInit: "jca",
  },
  {
    Id: "8D1F57A6-D8B5-4E96-A205-E7A2062D1CF0",
    TitelNr: 142,
    Titel: "Director",
    Navn: "Director",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:48:41.087Z",
    RetteInit: "jca",
  },
  {
    Id: "8E105C90-15E1-4C9F-B9E5-E9435C96B7A0",
    TitelNr: 231,
    Titel: "H.D.(Finan",
    Navn: "H.D.(Finansiering)",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:55:01.200Z",
    RetteInit: "jca",
  },
  {
    Id: "5872460D-FF69-45F4-8932-EAFD45A8872E",
    TitelNr: 348,
    Titel: "Laboranr",
    Navn: "Laborant",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T16:58:41.347Z",
    RetteInit: "jca",
  },
  {
    Id: "34F9A1EF-B098-4B4D-AD2F-EBF99BCB9807",
    TitelNr: 581,
    Titel: "Socialrådg",
    Navn: "Socialrådgiver",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:14:40.460Z",
    RetteInit: "jca",
  },
  {
    Id: "FB3E107A-A68F-4C27-B79F-EF06F8EEFA3E",
    TitelNr: 18,
    Titel: "Advokat",
    Navn: "Advokat",
    FalId: "56d0dd39-acec-47d0-8f03-9cf4d8cb17e1",
    FalReferenceDatatypeIndex: 3,
    FalSkjult: 0,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-05-13T12:36:48.373Z",
    RetteInit: "snk",
  },
  {
    Id: "8E34ACC2-9675-489F-84A2-F1D08B54B6C0",
    TitelNr: 32,
    Titel: "Afdelingsc",
    Navn: "Afdelingschef",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:40:42.787Z",
    RetteInit: "jca",
  },
  {
    Id: "A2904A2A-0A3D-4342-977B-F23B78DDDDB3",
    TitelNr: 525,
    Titel: "Rigsadv",
    Navn: "Rigsadvokat",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:10:49.593Z",
    RetteInit: "jca",
  },
  {
    Id: "9900070B-3A5C-463D-B1A7-F31C76A88CEA",
    TitelNr: 226,
    Titel: "H.D.",
    Navn: "H.D.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:54:31.123Z",
    RetteInit: "jca",
  },
  {
    Id: "D950A577-8920-440D-B7EF-F43BB943D652",
    TitelNr: 13,
    Titel: "Administra",
    Navn: "Administrator",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-09T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:39:38.433Z",
    RetteInit: "jca",
  },
  {
    Id: "F4BB456D-8B2E-4FA1-A67B-F6BDB789F6AB",
    TitelNr: 119,
    Titel: "Civiløkono",
    Navn: "Civiløkonom",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-03-17T23:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:47:18.873Z",
    RetteInit: "jca",
  },
  {
    Id: "A33C78C3-0471-494A-8430-F8D8950675BC",
    TitelNr: 532,
    Titel: "Sagfører",
    Navn: "Sagfører",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:11:18.733Z",
    RetteInit: "jca",
  },
  {
    Id: "CC4ECE50-EB69-46E5-98D3-FAFBE24C6F8C",
    TitelNr: 1,
    Titel: "1.viceborg",
    Navn: "1. viceborgmester",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2007-09-05T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:38:36.720Z",
    RetteInit: "jca",
  },
  {
    Id: "41195328-2E5A-4096-AFF0-FBFA00B55A86",
    TitelNr: 182,
    Titel: "Fast værge",
    Navn: "Fast værge",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T15:51:34.980Z",
    RetteInit: "jca",
  },
  {
    Id: "5CCB184B-1CC2-448A-9766-FC11CA9C767A",
    TitelNr: 398,
    Titel: "M.B.A.",
    Navn: "M.B.A.",
    FalId: null,
    FalReferenceDatatypeIndex: null,
    FalSkjult: 1,
    OpretDato: "2008-04-23T22:00:00.000Z",
    OpretInit: "jca",
    RetteDato: "2011-11-14T17:02:10.577Z",
    RetteInit: "jca",
  },
];
